import {Vector3} from 'three';
import {
    SnapCandidate,
    SnapState,
} from 'components/customer/RoomPlanner/helpers/snapping/types';

// A candidate scored by its distance to the drag target, the way the router
// has always compared these three algorithms' positions.
export const toCandidate = (
    position: Vector3 | null,
    targetPos: Vector3,
    snapState?: SnapState
): SnapCandidate | null =>
    position === null
        ? null
        : {position, distance: position.distanceTo(targetPos), snapState};
